import { Component, Vue } from 'vue-property-decorator'

import Loader from '@/components/Loader/index.vue'
import FieldPortal from '@/components/edit/FieldPortal/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'
import ManageArray from '@/components/edit/ManageArray/index.vue'
import LabelModified from '@/components/edit/LabelModified/index.vue'

import { validationMixin } from 'vuelidate'

import Control from '@/helpers/control'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import vSelect from 'vue-select'
import fetch from '@/helpers/fetch'
import { bus } from '@/main'

library.add(faTrashAlt)

Vue.component('v-select', vSelect)

@Component({
	components: {
		Loader,
		FieldPortal,
		MessageSuccess,
		ManageArray,
		LabelModified,
	},
	mixins: [validationMixin],
})
export default class ModalInitial extends Vue {
	control = new Control()

	costsStatusOptions = getCostsStatusOptions()
	statusOptions = getStatusOptions()
	modelOptions = getModelOptions()
	subjectMatterOptions = getSubjectMatterOptions()

	get fields() {
		return this.$store.state.initials.fields
	}

	get selectedInitialId() {
		return this.$store.state.initials.selectedInitialId
	}

	get initial() {
		return this.initialsById[this.selectedInitialId]
	}

	get initialsById() {
		return this.$store.state.initials.initialsById
	}

	get users() {
		return this.$store.state.user.usersList
	}

	// get subjects() {
	// 	return this.$store.state.subjects.subjectsList
	// }

	async mounted() {
		if (this.$store) {
			await Promise.all([
				this.$store.dispatch('fetchUsersList'),
				this.$store.dispatch('fetchSubjects'),
			])
		}
		bus.$on('get-groups-options', async () => {
			await this.getGroupOptions()
		})

		await this.getGroupOptions()
		await this.getSubjectsOptions()
	}

	groups = []
	async getGroupOptions() {
		const res = await fetch.get('/api/groups')
		if (res && res.ok) {
			this.groups = res?.data.map((group) => {
				return {
					id: group.id,
					name: group.name,
				}
			})
		}
	}

	subjects = []
	async getSubjectsOptions() {
		const res = await fetch.get('/api/calc/subjects')
		if (res && res.ok) {
			this.subjects = res?.data.map((calc_subject) => {
				return {
					id: calc_subject.id,
					name: calc_subject.name,
				}
			})
		}
	}

	getGroupName(initial) {
		const group = initial?.group

		if (group && group?.group?.name) {
			return group?.group?.name
		}
	}

	getGroupArray(initial) {
		const group = initial?.group
		if (group) {
			return [group.name]
		}
	}

	async onInput(field, value) {
		const initial: any = { id: this.selectedInitialId }

		initial[field] = value

		const debouncedSave = this.control.debounce(this.save, 500)
		await debouncedSave(initial)

		Vue.set(this.initial, field, value)
	}

	saving = false
	success = false
	async save(initial) {
		this.saving = true
		const res = await this.$store.dispatch('saveInitial', initial)
		this.saving = false

		if (res.ok) {
			this.success = true
			await this.$store.dispatch('fetchInitials')
		}
	}

	dateFormatOptions = {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	}

	dateDisabled(ymd, date) {
		// Disable weekends (Sunday = `0`, Saturday = `6`)
		const weekday = date.getDay()
		return weekday === 0 || weekday === 6
	}

	deletingTrigger = false
	onDeleteTrigger() {
		this.deletingTrigger = true
	}

	deleting = false
	async onConfirmInput($event) {
		const value = $event.target.value
		if (value.length === 13) {
			this.deleting = true

			const data = await fetch.delete(
				'/api/initial-management/' + this.selectedInitialId,
				{ password: value },
			)

			if (data && data.ok) {
				this.$bvModal.hide('modal-initial-management')
				this.deleting = false
				this.deletingTrigger = false
			} else {
				this.deleting = false
				this.deletingTrigger = false
			}
		}
	}
}

function getCostsStatusOptions() {
	return [
		{ value: '', text: '' },
		{ value: 'Pré-distribuição', text: 'Pré-distribuição' },
		{ value: 'Pós-distribuição', text: 'Pós-distribuição' },
		{ value: 'Pós-distribuição-isenção', text: 'Pós-distribuição-isenção' },
	]
}

function getStatusOptions() {
	return [
		{ value: '', text: '' },
		{ value: 'Ok', text: 'Ok' },
		{ value: '1ª Revisão', text: '1ª Revisão' },
		{ value: 'Parado', text: 'Parado' },
		{ value: 'Perdida', text: 'Perdida' },
		{ value: 'Protocolado', text: 'Protocolado' },
	]
}

function getModelOptions() {
	return [
		{ value: '', text: '' },
		{ value: true, text: 'Sim' },
		{ value: false, text: 'Não' },
	]
}

function getSubjectMatterOptions() {
	return [
		{ value: '', text: '' },
		{ value: 'Estadual', text: 'Estadual' },
		{ value: 'Federal', text: 'Federal' },
		{ value: 'Municipal', text: 'Municipal' },
	]
}
